<!-- 图标选择器 -->
<template>
  <div class="container">
    <el-popover :visible="state.visible" :teleported="false" :width="width" placement="bottom-end" trigger="click">
      <template #reference>
        <div @click="togglePopover">
          <el-input v-model="data" readonly placeholder="点击选择图标" class="reference">
            <template #prepend>
              <!-- 根据图标类型展示 -->
              <el-icon v-if="data.includes('el-icon-')">
                <component :is="data.replace('el-icon-', '')" />
              </el-icon>
              <template v-else>
                <svg-icon :icon-class="data" />
              </template>
            </template>
            <template #suffix>
              <!-- 清空按钮 -->
              <el-icon v-if="data" style="margin-right: 8px" @click.stop="clearSelectedIcon">
                <CircleClose />
              </el-icon>
              <el-icon :style="{
                transform: state.visible ? 'rotate(180deg)' : 'rotate(0)',
                transition: 'transform .5s',
              }">
                <ArrowDown @click.stop="togglePopover" />
              </el-icon>
            </template>
          </el-input>
        </div>
      </template>
      <div>
        <el-input v-model="state.iconText" placeholder="请输入图标名称" @input="handleFilter" />
        <el-tabs v-model="state.activeName">
          <el-tab-pane label="SVG图标" name="1">
            <el-scrollbar height="150px">
              <ul class="icon-list">
                <li class="icon-list-item" v-for="(item, i) in state.iconsList" :key="item" @click="selectIcon(item)">
                  <el-tooltip :content="item" placement="bottom" effect="light">
                    <SvgIcon :icon-class="item"></SvgIcon>
                  </el-tooltip>
                </li>
              </ul>
            </el-scrollbar>
          </el-tab-pane>
          <el-tab-pane label="Element图标" name="2">
            <el-scrollbar height="150px">
              <ul class="icon-list">
                <li class="icon-list-item" v-for="(item, i) in state.elementIconList" :key="item"
                  @click="selectIcon(item)">
                  <el-tooltip :content="item" placement="bottom" effect="light">
                    <el-icon>
                      <component :is="item" />
                    </el-icon>
                  </el-tooltip>
                </li>
              </ul>
            </el-scrollbar>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-popover>
  </div>
</template>

<script setup>
defineOptions({
  name: "iconSelect",
});
import { reactive, toRefs, onBeforeMount, onMounted, ref, watch } from "vue";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
console.log(ElementPlusIconsVue);
// 定义组件参数
defineProps({
  width: {
    type: String,
    default: "100%",
  },
});
// 接收v-model传值 modelValue 默认不写默认值
const data = defineModel({
  type: String,
  default: "",
});
const state = reactive({
  value: "",
  activeName: "1",
  visible: false,
  isElementIcon: false,
  iconsList: [],
  elementIconList: Object.keys(ElementPlusIconsVue),
  el_IconList: Object.keys(ElementPlusIconsVue),
  iconText:'',
  svgIcons:[]
});
// 查询图标名称
const GetIconsName = () => {
  const icons = import.meta.glob("../../assets/icons/*.svg", { eager: true });
  for (const path in icons) {
    const iconName = path.replace(/.*\/(.*)\.svg$/, "$1");
    state.iconsList.push(iconName);
    state.svgIcons = state.iconsList;
  }
};
// 选择图标
const selectIcon = (iconName) => {
  data.value = state.activeName === "2" ? `el-icon-${iconName}` : iconName;
  state.visible = false;
};
// 清空图标
const clearSelectedIcon = () => {
  data.value = "";
};
// 切换弹窗显示
const togglePopover = () => {
  state.visible = !state.visible;
};
// 过滤图标
const handleFilter = (val) => {
  if (state.activeName === "1") {
    state.iconsList = state.iconText? state.svgIcons.filter((icon) => icon.toLowerCase().includes(val.toLowerCase())): state.svgIcons;
  } else {
    state.elementIconList = state.iconText? state.el_IconList.filter((icon) => icon.toLowerCase().includes(val.toLowerCase())):state.el_IconList;
  }
}
onBeforeMount(() => { });
onMounted(() => {
  GetIconsName();
});
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
}

.reference :deep(.el-input__wrapper),
.reference :deep(.el-input__inner) {
  cursor: pointer;
}

.icon-list {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;
}

.icon-list-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  margin: 4px;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  transition: all 0.3s;
}

.icon-list-item:hover {
  border-color: #4080ff;
  transform: scale(1.2);
}
</style>
